import React from 'react';
import { getSeoData } from '../../utils/helpers';
import AgencyPage from '../../components/Views/AgencyPage';
import Layout from '../../components/Layout/Layout';

const Agency = () => <AgencyPage />;

Agency.getInitialProps = async ({ apolloClient, asPath, req, lng: ctxLng }) => {
  const seoData = await getSeoData(apolloClient, asPath, req);

  return {
    seoData,
    currentLang: ctxLng
  };
};

Agency.getLayout = page => (
  <Layout
    isBottomNavigation={false}
    isBanner={true}
    isShowBackButton
    isShowCloseButton={false}
  >
    {page}
  </Layout>
);

export default Agency;
